import { render, staticRenderFns } from "./UploadingPage.vue?vue&type=template&id=178f4b90&scoped=true&"
import script from "./UploadingPage.vue?vue&type=script&lang=js&"
export * from "./UploadingPage.vue?vue&type=script&lang=js&"
import style0 from "./UploadingPage.vue?vue&type=style&index=0&id=178f4b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f4b90",
  null
  
)

export default component.exports